/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * 顔貌
 */
export type FindEmsContactFacialAppearanceEnum =
  (typeof FindEmsContactFacialAppearanceEnum)[keyof typeof FindEmsContactFacialAppearanceEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FindEmsContactFacialAppearanceEnum = {
  NORMAL: 'NORMAL',
  JAUNDICE: 'JAUNDICE',
  FLUSHING: 'FLUSHING',
  PALE: 'PALE',
  ASHEN: 'ASHEN',
  CYANOSIS: 'CYANOSIS',
  SWEATING: 'SWEATING',
  COLD_SWEAT: 'COLD_SWEAT',
  OTHER: 'OTHER',
} as const;
